import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={23.042}
    height={25.7}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 56230 62719"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:none}.fil1{fill:#231f20}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974592727328">
        <path id="XMLID_80_" d="M21303 31602h6249" className="fil0" />
        <path id="XMLID_80__0" d="M28678 31602h6250" className="fil0" />
        <path
          id="XMLID_80__1"
          d="M44601 60383c-673-533-1389-314-2909-654 0 0-903-105-2522-936-10014-5140-8569-23703-8340-26268h4098v-923h-6250v923h-1126v-923h-6249v923h4097c229 2565 1674 21128-8340 26268-1619 831-2522 936-2522 936-1520 340-2236 121-2909 654-403 313-854 941-875 2336h34722c-21-1395-472-2023-875-2336z"
          className="fil1"
        />
        <path id="XMLID_79_" d="M0 0h4612v32525H0z" className="fil1" />
        <path id="XMLID_78_" d="M7374 0h4611v32525H7374z" className="fil1" />
        <path id="XMLID_77_" d="M14748 0h4612v32525h-4612z" className="fil1" />
        <path id="XMLID_76_" d="M36870 0h4611v32525h-4611z" className="fil1" />
        <path id="XMLID_75_" d="M44244 0h4612v32525h-4612z" className="fil1" />
        <path id="XMLID_74_" d="M51618 0h4612v32525h-4612z" className="fil1" />
        <path
          id="XMLID_77__2"
          d="M22126 0h4612v32525h-4612z"
          className="fil1"
        />
        <path
          id="XMLID_77__3"
          d="M29505 0h4612v32525h-4612z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
